<template>
    <div class="simple-form">
        <el-form :model="bankAccInfo" :rules="checkBankAccInfo" ref="ruleForm" class="demo-ruleForm">
            <div class="form-group center">
                <div class="form-label">
                    <label>付款卡号</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="payCardNo">
                        <el-input class="width-2x" v-model="bankAccInfo.payCardNo"></el-input>
                        <a class="swb-btn-link" @click="selectBuyerBankAcc()" v-if="buyerRealComId != null && buyerRealComId > 0">选择</a>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>付款银行</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="payBankName">
                        <el-input class="width-2x" v-model="bankAccInfo.payBankName"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>付款账号名称</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="payAcctName">
                        <el-input class="width-2x" v-model="bankAccInfo.payAcctName"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>付款账号</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="payAcctNo">
                        <el-input class="width-2x" v-model="bankAccInfo.payAcctNo"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>收款卡号</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="rcvCardNo">
                        <el-input class="width-2x" v-model="bankAccInfo.rcvCardNo"></el-input>
                        <a class="swb-btn-link" @click="selectBankAcc()" v-if="sellerRealComId != null && sellerRealComId > 0">选择</a>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>收款银行</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="rcvBankName">
                        <el-input class="width-2x" v-model="bankAccInfo.rcvBankName"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>收款账号名称</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="rcvAcctName">
                        <el-input class="width-2x" v-model="bankAccInfo.rcvAcctName"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>收款账号</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="rcvAcctNo">
                        <el-input class="width-2x" v-model="bankAccInfo.rcvAcctNo"></el-input>
                    </el-form-item>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'

    import {selectRealComBankAcctDialog} from '../merchtFinac/selectDlg'

    import contractApi from '../../api/contract'
    import merchtComnApi from '../../api/merchtComn'

    export default {
        name: 'swb-bank-acc-info',
        avlActions: '',
        avlScopes: 'retailer',
        desc: '金额预付',
        props: {
            payVoucherInfo: {
                type: Object,
                default: function () {
                    return {};
                }
            }
        },
        data: function () {
            let checkLength = function (rule, value, callback) {
                let field = rule.field;
                if (Utils.isNoB(value)) {
                    callback();
                } else {
                    if (field == 'payCardNo') {
                        if (value.length > 30) {
                            callback(new Error('付款卡号最多不能超过30个字'));
                        } else {
                            callback();
                        }
                    } else if (field == 'payBankName') {
                        if (value.length > 30) {
                            callback(new Error('付款银行最多不能超过30个字'));
                        } else {
                            callback();
                        }
                    } else if (field == 'payAcctName') {
                        if (value.length > 30) {
                            callback(new Error('付款账号名称最多不能超过30个字'));
                        } else {
                            callback();
                        }
                    } else if (field == 'payAcctNo') {
                        if (value.length > 30) {
                            callback(new Error('付款账号最多不能超过30个字'));
                        } else {
                            callback();
                        }
                    } else if (field == 'rcvCardNo') {
                        if (value.length > 30) {
                            callback(new Error('收款卡号最多不能超过30个字'));
                        } else {
                            callback();
                        }
                    } else if (field == 'rcvBankName') {
                        if (value.length > 30) {
                            callback(new Error('收款银行最多不能超过30个字'));
                        } else {
                            callback();
                        }
                    } else if (field == 'rcvAcctName') {
                        if (value.length > 30) {
                            callback(new Error('收款账号名称最多不能超过30个字'));
                        } else {
                            callback();
                        }
                    } else if (field == 'rcvAcctNo') {
                        if (value.length > 30) {
                            callback(new Error('收款账号最多不能超过30个字'));
                        } else {
                            callback();
                        }
                    }
                }
            };
            // 返回值
            return {
                //
                bankAccInfo: {},
                contractId: null,
                contractNo: null,
                sellerRealComId: null,
                buyerRealComId: null,
                //
                contranct: {},
                // 校验
                checkBankAccInfo: {
                    payCardNo: [{
                        validator: checkLength,
                        trigger: 'blur'
                    }],
                    payBankName: [{
                        validator: checkLength,
                        trigger: 'blur'
                    }],
                    payAcctName: [{
                        validator: checkLength,
                        trigger: 'blur'
                    }],
                    payAcctNo: [{
                        validator: checkLength,
                        trigger: 'blur'
                    }],
                    rcvCardNo: [{
                        validator: checkLength,
                        trigger: 'blur'
                    }],
                    rcvBankName: [{
                        validator: checkLength,
                        trigger: 'blur'
                    }],
                    rcvAcctName: [{
                        validator: checkLength,
                        trigger: 'blur'
                    }],
                    rcvAcctNo: [{
                        validator: checkLength,
                        trigger: 'blur'
                    }]
                }
            }
        },
        created: function () {
            //
            let payVoucherInfo = this.payVoucherInfo;
            if (!Utils.isNoB(payVoucherInfo) && payVoucherInfo.id > 0) {
                this.contractId = payVoucherInfo.contractId;
                this.contractNo = payVoucherInfo.contractNo;
                this.sellerRealComId = payVoucherInfo.sellerRealComId;
                this.buyerRealComId = payVoucherInfo.buyerRealComId;
                //
                let bankAccInfo = this.bankAccInfo || {};
                bankAccInfo.rcvCardNo = payVoucherInfo.rcvCardNo;
                bankAccInfo.rcvBankName = payVoucherInfo.rcvBankName;
                bankAccInfo.rcvAcctName = payVoucherInfo.rcvAcctName;
                bankAccInfo.rcvAcctNo = payVoucherInfo.rcvAcctNo;
                bankAccInfo.payCardNo = payVoucherInfo.payCardNo;
                bankAccInfo.payBankName = payVoucherInfo.payBankName;
                bankAccInfo.payAcctName = payVoucherInfo.payAcctName;
                bankAccInfo.payAcctNo = payVoucherInfo.payAcctNo;
                this.bankAccInfo = Utils.merge({}, bankAccInfo);
            }
            //
            if (!Utils.isNoB(this.contractId) && this.contractId > 0 && Utils.isNoB(payVoucherInfo.rcvCardNo)) {
                this.getContractInfo(this.contractId, null);
            } else if (!Utils.isNoB(this.contractNo) && Utils.isNoB(payVoucherInfo.rcvCardNo)) {
                this.getContractInfo(null, this.contractNo);
            } else if (!Utils.isNoB(this.sellerRealComId) && this.sellerRealComId > 0 && Utils.isNoB(payVoucherInfo.rcvCardNo)) {
                // 获取卖方默认收款账号信息
                this.getSellerBankAccInfo();
            }
            //
            if (!Utils.isNoB(this.buyerRealComId) && this.buyerRealComId > 0 && Utils.isNoB(payVoucherInfo.payCardNo)) {
                // 获取买方默认收款账号信息
                this.getBuyerBankAccInfo();
            }
        },
        methods: {
            getContractInfo: function (contractId, contractNo) {
                let self = this;
                let postData = {};
                postData.id = contractId;
                postData.no = contractNo;
                //
                let lastMsgBoxDlg = MsgBox.loading();
                contractApi.getContractInfo(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if (result.type == "info") {
                        let contranct = result.data;
                        //
                        let rcvCardNo = contranct.sndPartyCardNo || null;
                        let rcvBankName = contranct.sndPartyBankName || null;
                        let rcvAcctName = contranct.sndPartyAcctName || null;
                        let rcvAcctNo = contranct.sndPartyAcctNo || null;
                        if (!Utils.isNoB(rcvCardNo) || !Utils.isNoB(rcvBankName) || !Utils.isNoB(rcvAcctName) || !Utils.isNoB(rcvAcctNo)) {
                            let bankAccInfo = self.bankAccInfo || {};
                            bankAccInfo.rcvCardNo = rcvCardNo;
                            bankAccInfo.rcvBankName = rcvBankName;
                            bankAccInfo.rcvAcctName = rcvAcctName;
                            bankAccInfo.rcvAcctNo = rcvAcctNo;
                            //
                            self.bankAccInfo = Utils.merge({}, bankAccInfo);
                        } else if (!Utils.isNoB(self.sellerRealComId) && self.sellerRealComId > 0) {
                            self.getSellerBankAccInfo();
                        }
                        //
                        self.contranct = Utils.merge({}, contranct);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 获取卖方默认收款账号信息
            getSellerBankAccInfo: function () {
                let self = this;
                let postData = {};
                postData.realComId = self.sellerRealComId;
                postData.acctUsage = getEnumInfoWith('bankAcctUsage', 'name', 'Shroff').value;
                //
                let lastMsgBoxDlg = MsgBox.loading();
                merchtComnApi.getRealComBankAcctDefaulted(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if (result.type == "info") {
                        let bankAcct = result.data || {};
                        //
                        if (!Utils.isNoB(bankAcct) && bankAcct.id > 0) {
                            let bankAccInfo = self.bankAccInfo || {};
                            bankAccInfo.rcvCardNo = bankAcct.cardNo;
                            bankAccInfo.rcvBankName = bankAcct.bankName;
                            bankAccInfo.rcvAcctName = bankAcct.acctName;
                            bankAccInfo.rcvAcctNo = bankAcct.acctNo;
                            //
                            self.bankAccInfo = Utils.merge({}, bankAccInfo);
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 获取买方默认收款账号信息
            getBuyerBankAccInfo: function () {
                let self = this;
                let postData = {};
                postData.realComId = self.buyerRealComId;
                postData.acctUsage = getEnumInfoWith('bankAcctUsage', 'name', 'Payment').value;
                //
                let lastMsgBoxDlg = MsgBox.loading();
                merchtComnApi.getRealComBankAcctDefaulted(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if (result.type == "info") {
                        let bankAcct = result.data || {};
                        //
                        if (!Utils.isNoB(bankAcct) && bankAcct.id > 0) {
                            let bankAccInfo = self.bankAccInfo || {};
                            bankAccInfo.payCardNo = bankAcct.cardNo;
                            bankAccInfo.payBankName = bankAcct.bankName;
                            bankAccInfo.payAcctName = bankAcct.acctName;
                            bankAccInfo.payAcctNo = bankAcct.acctNo;
                            //
                            self.bankAccInfo = Utils.merge({}, bankAccInfo);
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 选择付款账号
            selectBuyerBankAcc: function () {
                let self = this;
                let params = {
                    realComId: self.buyerRealComId,
                    checkBox: false,
                    usage: getEnumInfoWith('bankAcctUsage', 'name', 'Payment').value
                };
                selectRealComBankAcctDialog(params, function (bankAcct) {
                    bankAcct = bankAcct || {};
                    if (!Utils.isNoB(bankAcct) && bankAcct.id > 0) {
                        let bankAccInfo = self.bankAccInfo || {};
                        bankAccInfo.payCardNo = bankAcct.cardNo;
                        bankAccInfo.payBankName = bankAcct.bankName;
                        bankAccInfo.payAcctName = bankAcct.acctName;
                        bankAccInfo.payAcctNo = bankAcct.acctNo;
                        //
                        self.bankAccInfo = Utils.merge({}, bankAccInfo);
                    } else {
                        MsgBox.warning("请选择银行卡信息！");
                    }
                });
            },
            // 选择银行卡
            selectBankAcc: function () {
                let self = this;
                let params = {
                    realComId: self.sellerRealComId,
                    checkBox: false,
                    usage: getEnumInfoWith('bankAcctUsage', 'name', 'Shroff').value
                };
                selectRealComBankAcctDialog(params, function (bankAcct) {
                    bankAcct = bankAcct || {};
                    if (!Utils.isNoB(bankAcct) && bankAcct.id > 0) {
                        let bankAccInfo = self.bankAccInfo || {};
                        bankAccInfo.rcvCardNo = bankAcct.cardNo;
                        bankAccInfo.rcvBankName = bankAcct.bankName;
                        bankAccInfo.rcvAcctName = bankAcct.acctName;
                        bankAccInfo.rcvAcctNo = bankAcct.acctNo;
                        //
                        self.bankAccInfo = Utils.merge({}, bankAccInfo);
                    } else {
                        MsgBox.warning("请选择银行卡信息！");
                    }
                });
            },
            //
            getDlgResult: function () {
                let self = this;
                let result = {};
                // 表单校验
                self.$refs['ruleForm'].validate(function (valid) {
                    if (valid) {
                        //
                        let bankAccInfo = self.bankAccInfo || {};
                        let rcvCardNo = bankAccInfo.rcvCardNo;
                        let rcvBankName = bankAccInfo.rcvBankName;
                        let rcvAcctName = bankAccInfo.rcvAcctName;
                        let rcvAcctNo = bankAccInfo.rcvAcctNo;
                        let payCardNo = bankAccInfo.payCardNo;
                        let payBankName = bankAccInfo.payBankName;
                        let payAcctName = bankAccInfo.payAcctName;
                        let payAcctNo = bankAccInfo.payAcctNo;
                        let errMsg = '';
                        if (Utils.isNoB(rcvCardNo) && Utils.isNoB(rcvBankName) && Utils.isNoB(rcvAcctName) && Utils.isNoB(rcvAcctNo) //
                            && Utils.isNoB(payCardNo) && Utils.isNoB(payBankName) && Utils.isNoB(payAcctName) && Utils.isNoB(payAcctNo)) {
                            errMsg = "您没有输入任何信息！";
                        } else {
                            //
                            if (!Utils.isNoB(self.contractId)) {
                                //
                                let contranct = self.contranct || {};
                                if (!Utils.isNoB(contranct) && contranct.id > 0) {
                                    let rcvCardNo = contranct.sndPartyCardNo || null;
                                    let rcvBankName = contranct.sndPartyBankName || null;
                                    let rcvAcctName = contranct.sndPartyAcctName || null;
                                    let rcvAcctNo = contranct.sndPartyAcctNo || null;
                                    let needHint = false;
                                    if (!Utils.isNoB(rcvCardNo) && rcvCardNo != bankAccInfo.rcvCardNo) {
                                        needHint = true;
                                    }
                                    if (!Utils.isNoB(rcvBankName) && rcvBankName != bankAccInfo.rcvBankName) {
                                        needHint = true;
                                    }
                                    if (!Utils.isNoB(rcvAcctName) && rcvAcctName != bankAccInfo.rcvAcctName) {
                                        needHint = true;
                                    }
                                    if (!Utils.isNoB(rcvAcctNo) && rcvAcctNo != bankAccInfo.rcvAcctNo) {
                                        needHint = true;
                                    }
                                    if (Utils.isTrue(needHint)) {
                                        bankAccInfo.hintMsg = '您好！收款的银行卡信息与签订合同中的银行卡信息不一致，请您再次确认是否使用！';
                                    }
                                }
                            }
                        }
                        //
                        result.type = 'info';
                        if (!Utils.isNoB(errMsg)) {
                            result.type = 'warn';
                        }
                        result.data = bankAccInfo;
                        result.message = errMsg;
                    } else {
                        result.type = 'warn';
                        result.message = '校验失败！';
                    }
                });
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/settle/BankAccInfo.vue